export { TrustpilotWidget } from './TrustpilotWidget';
